"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var report_menu_html_1 = __importDefault(require("./report-menu.html"));
(function (module) {
    ReportMenuController.$inject = [
        '$filter',
        'prActiveReport',
        'prCreateReportModal',
        'prEventService',
        'prReportMenuService'
    ];
    function ReportMenuController($filter, report, createReportModal, eventService, reportMenuService) {
        var $ctrl = this, translate = $filter('translate');
        $ctrl.label = report.getDescription();
        eventService.on('reportRenamed', setReportMenuLabel);
        angular.extend($ctrl, {
            id: 'REPORT',
            getMenuItems: function () {
                return reportMenuService.getMenuItems().then(function (reportMenuItems) {
                    return [
                        {
                            label: translate('DASHBOARD_MENU.NEW'),
                            action: openCreateReportModal,
                            icon: 'icon-plus',
                            replaceCheck: true
                        }
                    ].concat({ divider: true }, reportMenuItems);
                });
            }
        });
        function setReportMenuLabel(event, reportName) {
            report.updateDocumentTitle(reportName);
            $ctrl.label = reportName;
        }
        function openCreateReportModal() {
            createReportModal.show();
        }
    }
    module.component('prReportMenu', {
        controller: ReportMenuController,
        templateUrl: report_menu_html_1.default,
        require: {
            fbCtrl: '^^prFilebar'
        }
    });
}(angular.module('qualtrics.pr')));
